<template>
  <div class="tab">
    <el-footer v-if="$can('create', 'intercoms')" class="tab__footer page__active_bar">
      <el-button
        id="addIntercom"
        class="page__active_button"
        type="primary"
        icon="el-icon-plus"
        @click="$router.push({ name: 'intercom:create' })"
      >
        Добавить
      </el-button>
    </el-footer>
    <div class="page_container">
      <search :query.sync="query" @search="search" />
      <intercoms-table @intercomDeleted="changePage(page)" />
      <el-pagination
        class="list__pagination"
        layout="prev, pager, next"
        :page-size="count"
        :total="total"
        :current-page="page"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import list from "@/core/mixins/list";
import IntercomsTable from "@/components/Intercoms/features/IntercomsTable";

export default {
  name: "IntercomsList",
  components: {
    IntercomsTable,
    Search,
  },
  mixins: [list],
  data() {
    return { query: "", activeName: "list" };
  },
  computed: {
    ...mapState("intercoms", ["total", "count"]),
    ...mapGetters("intercoms", ["getQuery"]),
  },
  methods: {
    ...mapActions("intercoms", {
      getList: "GET_LIST_INTERCOMS",
    }),
    ...mapMutations("intercoms", {
      setQuery: "SET_QUERY",
    }),
  },
};
</script>

<style>
.list,
.list__pagination {
  margin: 20px 0;
}
.list__pagination {
  text-align: center;
}
.el-table th > .cell {
  word-break: break-word;
}
.link {
  line-height: 1;
  cursor: pointer;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  color: #409eff;
}
</style>
